export default {
  "b2b.zdroje-typy-grid.label": "Typy zdrojů"
};
